<template>
<div>
  <div
    v-if="user"
    :style="{ position: 'relative' }"
    class="account-dropdown"
  >
    <img
      id="accountDropdownIcon"
      :class="'account-dropdown-icon' + (user.avatar ? '' : ' avatar-placeholder')"
      alt="account-dropdown"
      :title="user.displayName"
      :src="user.avatar ?? defaultAvatar"
      @error="handleBrokenImage"
      @click="toggleOpen('account')"
    />
    <div v-if="open" class="account-dropdown-menu">
      <div class="account-dropdown-item account-dropdown-item-user">
        <span class="account-dropdown-menu-title">Signed in as</span>
        <span>{{ user.displayName }}</span>
        <span>{{ user.email }}</span>
      </div>
      <span class="account-dropdown-divider"/>
      <div
        id="signOutLink"
        class="account-dropdown-item sign-out"
        @click="handleClickSignOut"
      >
        Sign Out
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'NavbarAccountDropdown',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    toggleOpen: {
      type: Function,
      required: true,
    },
    user: {
      type: Object,
    },
    defaultAvatar: {
      required: true,
    },
    domain: {
      type: String,
      default: 'tagboard.com',
    },
  },
  methods: {
    handleClickSignOut() {
      window.open(`https://user.${this.domain}/logout`,'_self');
    },
  
    handleBrokenImage(event) {
      event.target.classList.add('avatar-placeholder');
      event.target.src = this.defaultAvatar;
      event.target.onerror = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./NavbarVars";

.account-dropdown {
}
.account-dropdown-icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 100%;
  vertical-align: middle;
  border: 2px solid $tgb-border;
  box-sizing: border-box;
  transition: all 250ms ease-in-out;

  &:hover {
    border-color: $tgb-primary-accent;
  }

  &.avatar-placeholder {
    padding: 0.3125rem;
  }
}
.account-dropdown-menu {
  position: absolute;
  right: 0;
  background-color: $white;
  border: 1px solid $tgb-border;
  border-radius: $tgb-border-radius;
  white-space: nowrap;
  font-size: 0.875rem;
  text-align: left;
  min-width: 10.9375rem;
  box-shadow: 3px 3px 0.625rem $tgb-primary-font-dark;

  .account-dropdown-menu-title {
    font-weight: 900;
    font-size: 0.75rem;
    text-transform: uppercase;
    line-height: 1.5625rem;
    margin-bottom: 0.5rem;
    color: $tgb-trinary-font;
  }

  .account-dropdown-item {
    padding: 0 0.9375rem;
    line-height: 2.5rem;

    &:hover {
      background-color: $tgb-menu-hover;
    }

    &.account-dropdown-item-user {
      padding: 0.9375rem;
      line-height: initial;

      &:hover {
        cursor: initial;
        background-color: unset;
      }

      span {
        display: block;
      }
    }

    i {
      float: right;
      line-height: 2.5rem;
    }
  }

  .account-dropdown-divider {
    display: block;
    border-top: 1px solid $tgb-border;
  }
}

.dark {
  .account-dropdown-icon {
    &:hover {
      border-color: $tgb-secondary-font;
    }
  }

  .account-dropdown-menu {
    background: $tgb-navbar-dark;
    color: $tgb-primary-font-dark;
    border: 1px solid $tgb-primary-icon-hover-dark;
    border-radius: 3px;
    box-shadow: 3px 3px 0.625rem $tgb-navbar-dark;
  }

  .account-dropdown-item {
    &:hover {
      background-color: $tgb-primary-icon-hover-dark;
    }
  }

  .account-dropdown-divider {
    border-top: 1px solid $tgb-primary-icon-hover-dark;
  }
}

.dark-alt {
  .account-dropdown-icon {
    &:hover {
      border-color: $tgb-secondary-font;
    }
  }

  .account-dropdown-menu {
    background: $tgb-navbar-dark-alt;
    color: $tgb-primary-font-dark;
    border: 1px solid $tgb-primary-icon-hover-dark-alt;
    border-radius: 3px;
    box-shadow: 3px 3px 0.625rem $tgb-navbar-dark;
  }

  .account-dropdown-item {
    &:hover {
      background-color: $tgb-primary-icon-hover-dark-alt;
    }
  }

  .account-dropdown-divider {
    border-top: 1px solid $tgb-primary-icon-hover-dark-alt;
  }
}
</style>
